import { h, Fragment } from 'preact';
import { useState, useRef } from 'preact/hooks';
import clsx from 'clsx';
import VideoControl from './videoControls';
import SPDVideoControl from './spdVideoControls';

const VideoSrcPlayer = ({
  sources,
  videoContainerClasses,
  videoClasses,
  showControls = true,
  iconColor = '#FF5200',
  autoplay = true,
  poster = null,
  useSPDControls = false,
  showVolumeControl = true,
  ...videoProps
}) => {
  const [isMuted, setIsMuted] = useState(true);
  const [isPlaying, setIsPlaying] = useState(autoplay);
  const video = useRef();

  const handlePlay = (e) => {
    if (!video?.current) return;
    if (isPlaying) {
      e.preventDefault();
      video.current.pause();
      setIsPlaying(false);
    } else {
      e.preventDefault();
      video.current.play();
      setIsPlaying(true);
    }
  };

  const handleSound = (e) => {
    if (!video?.current) return;
    if (isMuted) {
      e.preventDefault();
      video.current.muted = false;
      setIsMuted(false);
    } else {
      e.preventDefault();
      video.current.muted = true;
      setIsMuted(true);
    }
  };

  return (
    <div className={clsx('relative', videoContainerClasses)}>
      {showControls &&
        (useSPDControls ? (
          <>
            <SPDVideoControl
              toggleType="pause"
              handleClick={handlePlay}
              isActive={isPlaying}
              className="absolute z-1 cursor-pointer bottom-5 right-5 lg:bottom-10 lg:right-10"
            />
            {showVolumeControl && (
              <SPDVideoControl
                toggleType="volume"
                handleClick={handleSound}
                isActive={isMuted}
                className="absolute z-1 cursor-pointer bottom-5 right-5 lg:bottom-10 lg:right-10 -translate-x-[50px]"
              />
            )}
          </>
        ) : (
          <>
            <VideoControl
              toggleType="pause"
              handleClick={handlePlay}
              isActive={isPlaying}
              iconColor={iconColor}
              className="absolute z-1 cursor-pointer bottom-5 right-5 lg:bottom-10 lg:right-10"
            />
            {showVolumeControl && (
              <VideoControl
                toggleType="volume"
                handleClick={handleSound}
                isActive={isMuted}
                iconColor={iconColor}
                className="absolute z-1 cursor-pointer bottom-5 right-5 lg:bottom-10 lg:right-10 -translate-x-[50px]"
              />
            )}
          </>
        ))}
      <video
        muted
        autoplay={autoplay}
        ref={video}
        loop
        playsInline
        class={clsx(videoClasses)}
        poster={poster}
        {...videoProps}
      >
        {[...sources]
          .sort((a, b) => {
            const aIsMp4 = a.mimeType === 'video/mp4' ? 0 : 1;
            const bIsMp4 = b.mimeType === 'video/mp4' ? 0 : 1;
            return aIsMp4 - bIsMp4;
          })
          .map((source, index) => (
            <source key={index} src={source.url} type={source.mimeType} />
          ))}
      </video>
    </div>
  );
};

export default VideoSrcPlayer;
